var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "108px",
    height: "46px",
    viewBox: "0 0 108 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: 1,
    fill: "#F4F0F5",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.8025,-1.0658141e-13 C59.4511714,-1.0658141e-13 64.7132925,1.6110408 69.2082368,4.3590246 C80.9084215,10.4985168 82.8115528,24.418266 88.1447636,33.6713472 C88.2901578,33.9236729 88.4460609,34.1742051 88.6128416,34.422859 C92.2866213,40.989204 99.1833433,45.49565 107.152948,45.7985796 L107.57338,45.8106303 L107.57338,45.8329218 L0.304063647,45.8329218 L0.304063647,45.8106303 L0.715155752,45.7989823 C9.87533385,45.4556924 17.6203773,39.557548 20.6845516,31.3603912 C25.1619118,22.2346549 27.6353408,10.0059157 38.3967632,4.3590246 C42.8917075,1.6110408 48.1538286,-1.0658141e-13 53.8025,-1.0658141e-13 Z",
    fill: "currentColor"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotch);
export default __webpack_public_path__ + "static/media/notch.3306ff35.svg";
export { ForwardRef as ReactComponent };